import { render, staticRenderFns } from "./CodemirrorLineWrappingBtn.vue?vue&type=template&id=1ea4255c"
import script from "./CodemirrorLineWrappingBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorLineWrappingBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports